<template>
  <span>
    <!-- <v-container pa-0 >
      <v-layout row wrap>
        <v-flex xs12> -->
          <v-menu
            :disabled="('disabled' in $attrs)?$attrs.disabled:false || ('readonly' in $attrs)?true:false"
            :close-on-content-click="false"
            ref="menu"
            v-model="menu"
            transition="scale-transition"
            max-width="290px"
            min-width="auto"
            center
            bottom
            offset-y
            :nudge-top="20"
          >
            <!-- :nudge-right="-40"
             -->
          
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-bind="$attrs"
                v-on="on"
                :label="label"
                append-icon="event"
                v-model="formatted"
                :clearable="('readonly' in $attrs)?false:true"
                readonly
                :rules="rules"              
                @blur="dateValue = parseDate(formatted)"
                :dense="('dense' in $attrs)?$attrs.dense:true" 
                :filled="('filled' in $attrs)?$attrs.filled:true" 
                @click:clear="setClear"
                @click:append="menu = !menu"
              >
              </v-text-field>
            </template>
            <v-date-picker
              :disabled="('disabled' in $attrs)?$attrs.disabled:false || ('readonly' in $attrs)?true:false"
              v-model="dateValue"
              locale="th-TH"
              no-title
              scrollable
              actions1
              :show-current="true"
              @input="dateInput($event)"
              @change="save"
            >
              <!-- :autosave="false" -->
              <template slot-scope="{ }">
                <v-card-actions>
                  <!-- <v-spacer></v-spacer> -->
                  <v-btn class="" small text color="primary" :disabled="('disabled' in $attrs)?$attrs.disabled:false || ('readonly' in $attrs)?true:false" @click="today()">{{todayText}}</v-btn>
                  <v-btn class="" small text color="primary" :disabled="('disabled' in $attrs)?$attrs.disabled:false || ('readonly' in $attrs)?true:false" @click="menu=false">Cancel</v-btn>
                </v-card-actions>
              </template>
            </v-date-picker>
          </v-menu>
          <!-- {{value}}|{{dateValue}}|{{formatted}} -->
        <!-- </v-flex>
      </v-layout>
    </v-container> -->
  </span>
</template>

<script>
  export default {
    data: () => ({
      menu: false,
      dateValue: null,
      formatted: null,
      todayText: 'To Day'
    }),
    props: {
      rules: {
        type: Array
      },
      value: {
        type: String,
        default: ''
      },      
      label: {
        type: String,
        default: ''
      },
      starttoday: {
        type: String,
        default: ''
      },
      // readonly: {
      //   type: Boolean,
      //   default: false
      // }
    },
    mounted: function () {
      // console.log('starttoday', (this.starttoday === 'true'))
      if (this.starttoday === 'true') {
        // console.log('starttoday', (new Date()).toISOString().slice(0, 10))
        this.setToday()
      } else {
        // console.log('starttoday', (new Date()).toISOString().slice(0, 10))
        // this.value = ''
      }
      this.formatValue()
    },
    watch: {
      value (old, newVal) {
        if(old !== newVal) {
          this.formatValue()
        }
        // this.formatValue()
        // if (this.value) {
        //   var d = (this.value.slice(0, 19))
        //   if (d !== this.dateValue) {
        //     this.formatValue()
        //   }
        // } else {

        // }
      },
      formatted () {
      }
    },
    computed:{
      isDisabled(){
        if('disabled' in $attrs) {
          if($attrs.disabled === '') {
            return true || ('readonly' in $attrs)?true:false
          } else {
            return $attrs.disabled || ('readonly' in $attrs)?true:false
          }
           
        }else{
          return false || ('readonly' in $attrs)?true:false
        }
      }
    },
    methods: {
      save (date) {
        this.$refs.menu.save(date)
      },
      dateInput(e){
        // console.log('dateinput',e)
        this.formatted = this.formatDate(e)
      },
      formatDate (date) {
        // console.log('formatDate',date)
        if (!date) {
          return null
        }

        var [year, month, day] = date.split('-')
        year = parseInt(year) + 543
        this.$emit('input', this.dateValue)
        return `${day}/${month}/${year}`
      },
      parseDate (date) {
        // console.log('parseDate', date)
        if (!date) {
          return null
        }
        var [day, month, year] = date.split('/')
        // console.log('parseDate - year', year)
        year = parseInt(year) - 543
        let dateParseInt = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
        if(this.value !== dateParseInt){
          // console.log('emit parseDate', date)
          this.$emit('input', dateParseInt)
        }
        // this.$emit('input', `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`)
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
      },
      today () {
        // console.log('today()')
        const tod = (new Date()).toISOString().slice(0, 10)
        if (this.value !== tod) {
          this.dateValue = tod
          this.formatted = this.formatDate(this.dateValue)
        } else {
          this.dateValue = ''
          this.formatted = ''
        }
        if (tod === this.dateValue) {
          this.todayText = 'Delete'
        } else {
          this.todayText = 'To Day'
        }
        this.$emit('input', this.dateValue)
      },
      setToday () {
        // console.log('setToday()')

        const tod = (new Date()).toISOString().slice(0, 10)
        // this.value = tod
        this.dateValue = tod
        this.formatted = this.formatDate(this.dateValue)
        this.todayText = 'Delete'
        this.$emit('input', this.dateValue)
      },
      setNull () {
        this.dateValue = null
        this.formatted = ''
        this.todayText = 'To Day'
        this.$emit('input', this.dateValue)
      },
      setClear () {
        this.dateValue = ''
        this.formatted = ''
        this.todayText = 'To Day'
        this.$emit('input', this.dateValue)
      },
      formatValue: function () {
        // console.log('formatValue-01', this.value)
        // this.dateValue = new Date(this.value.slice(0, 10))
        if(this.value === null){
          this.dateValue = null
          this.formatted = ''
          this.todayText = 'Today'
          return           
        }
        this.dateValue = (this.value.slice(0, 10))
        this.formatted = this.formatDate(this.dateValue)
        const tod = (new Date()).toISOString().slice(0, 10)
        if (tod === this.dateValue) {
          this.todayText = 'Delete'
        }
        // this.formatted = this.Date2Text(this.value)
        // this.$refs.Input.value = this.Date2Text(this.value)
        // console.log('formatValue-03  ok', this.dateValue)
      }
    }
  }
</script>

<style scoped>

</style>
